import angular from 'angular';
import uiRouter from 'angular-ui-router';
import racedaysPageComponent from './racedaysPage.component';

let racedaysPageModule = angular.module('racedaysPage', [
  uiRouter
])

.component('racedaysPage', racedaysPageComponent)

.name;

export default racedaysPageModule;
